<template>
  <div class="col-sm-6 nopads top-margin">
      <span class="title mt-3" style="font-size: 1.4em; color:  #0b4b8f">
        {{ $t('users.change_password_title') }}
      </span>
      <div class="row my-1">
          <div class="input-group">
              <input
                  v-model="currentPassword"
                  :type="showCurrentPassword ? 'text' : 'password'"
                  :placeholder="$t('users.current_password')"
                  class="form-control form-control-sm"
                  required
                  autocomplete="none"
              />
              <button
                  class="btn btn-light btn-sm"
                  style="max-height: 3.3em; border: #BCBCBC 1px solid"
                  @mousedown="showCurrentPassword = true"
                  @mouseup="showCurrentPassword = false"
                  @mouseout="showCurrentPassword = false"
              >
                  <i class="fas fa-eye"></i>
              </button>
          </div>
      </div>
      <div class="row my-1">
          <div class="input-group">
              <input
                  v-model="newPassword"
                  :type="showNewPassword ? 'text' : 'password'"
                  :placeholder="$t('users.new_password')"
                  class="form-control form-control-sm"
                  required
                  autocomplete="none"
                  @input="validatePassword"
              />
              <button
                  class="btn btn-light btn-sm"
                  style="max-height: 3.3em; border: #BCBCBC 1px solid"
                  @mousedown="showNewPassword = true"
                  @mouseup="showNewPassword = false"
                  @mouseout="showNewPassword = false"
              >
                  <i class="fas fa-eye"></i>
              </button>
          </div>
      </div>
      <div class="row my-1">
          <div class="input-group">
              <input
                  v-model="confirmPassword"
                  :disabled="!passwordOk"
                  :type="showConfirmPassword ? 'text' : 'password'"
                  :placeholder="$t('users.password_again')"
                  class="form-control form-control-sm"
                  required
                  autocomplete="none"
                  @input="validateConfirmPassword"
              />
              <button
                  class="btn btn-light btn-sm"
                  :disabled="!passwordOk"
                  @mousedown="showConfirmPassword = true"
                  @mouseup="showConfirmPassword = false"
                  @mouseout="showConfirmPassword = false"
              >
                  <i class="fas fa-eye"></i>
              </button>
          </div>
      </div>

      <ul v-if="passwordErrors.length > 0" class="mt-2 ps-3">
          <li v-for="error in passwordErrors" :key="error" class="text-danger small" style="margin-top: 0.25em; list-style: disc;">
              <i class="fas fa-exclamation-circle me-2"></i>{{ error }}
          </li>
      </ul>
      <div class="row">
          <span v-if="passwordChanged && newPassword.length < 1">{{ $t('users.password_set_ok') }}</span>
          <span v-if="error && newPassword.length < 1" class="error">
            {{ $t('users.password_set_err') }}
        </span>
      </div>
      <div class="col-12 d-flex justify-content-end my-2">
        <button
            class="btn btn-primary form-button"
            :disabled="!confirmPasswordOk"
            @click.stop="changePassword"
        >
          {{ $t('users.change_password_title') }}
        </button>
      </div>

    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {inject} from "vue";
export default {
    name: 'ChangePassword',
    mixins: [restApi],
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data() {
        return {
            currentPassword: '',
            newPassword: '',
            confirmPassword: '',
            passwordOk: false,
            confirmPasswordOk: false,
            passwordChanged: false,
            error: false,
            loading: false,
            showCurrentPassword: false,
            showNewPassword: false,
            showConfirmPassword: false,
            passwordErrors: [],
            errorMessages: [],
        }
    },

    methods: {

        changePassword: function () {
            this.loading = true
            this.restUpdate(this.changePasswordUrl, {
                old: this.currentPassword,
                new: this.newPassword
            }, this.success, this.fail)
        },
        success: function () {
            this.loading = false
            this.currentPassword = ''
            this.newPassword = ''
            this.confirmPassword = ''
            this.passwordChanged = true
            this.error = false
            this.showAlert(this.$t('users.password_set_ok'), 'success')
        },
        fail: function (response) {
            this.loading = false
            this.passwordChanged = false
            this.error = true

            if(response.data && response.data.errors && response.data.errors.length > 0) {
                this.errorMessages = response.data.errors
                this.passwordErrors = [];

                this.errorMessages.forEach((msg) => {
                    this.passwordErrors.push(this.$t(`validation.${msg}`))
                })
            } else {
                this.showAlert(this.$t('users.password_set_err'))
            }
        },
        validatePassword: function () {
            if (this.errorMessages.length > 0) {
                this.errorMessages = [];
            }

            this.passwordErrors = [];
            this.passwordOk = true;

            if (this.newPassword.length < 12) {
                this.passwordErrors.push(this.$t('validation.password_min_length'));
                this.passwordOk = false;
            }

            if (!/[A-ZÄÖÅ]/.test(this.newPassword)) {
                this.passwordErrors.push(this.$t('validation.password_uppercase'));
                this.passwordOk = false;
            }

            if (!/[a-zäöå]/.test(this.newPassword)) {
                this.passwordErrors.push(this.$t('validation.password_lowercase'));
                this.passwordOk = false;
            }

            if (!/[0-9]/.test(this.newPassword)) {
                this.passwordErrors.push(this.$t('validation.password_number'));
                this.passwordOk = false;
            }

            if (!/[^A-Za-z0-9äöåÄÖÅ]/.test(this.newPassword)) {
                this.passwordErrors.push(this.$t('validation.password_special'));
                this.passwordOk = false;
            }

            this.confirmPasswordOk = (this.confirmPassword === this.newPassword)
        },

        validateConfirmPassword: function () {
            this.confirmPasswordOk = (
                this.passwordOk &&
                this.confirmPassword.length > 0 &&
                this.newPassword === this.confirmPassword
            )
        }
    }
}
</script>
<style>
</style>
